import { Restaurant } from "../types";

export enum Rid {
  ChefPillai,
  AslamDelhi,
  Karims,
  HuddlesCafe,
  Paragon,
  Qureshi,
  Manali,
  OldSkool
}

export const restaurantList: Restaurant[] = [
  {
    name: "Chef Pillai",
    id: Rid.ChefPillai,
    location: {
      place: "Kochi",
      url: "https://goo.gl/maps/QUJ4zwapMxCUd9Hb8",
    },
    website: "https://chefpillai.com/",
  },
  {
    name: "Karim's",
    id: Rid.Karims,
    location: {
      place: "Delhi",
      url: "https://goo.gl/maps/sF3tu9TKfosbQVPC8",
    },
    website: "https://karimhotels.com/",
  },
  {
    name: "Huddles Cafe",
    id: Rid.HuddlesCafe,
    location: {
      place: "Trivandrum",
      url: "https://goo.gl/maps/qLWXqd2M44cDwWho8",
    },
    website: "https://huddlescafe.com/",
  },
  {
    name: "Aslam Chicken",
    id: Rid.AslamDelhi,
    location: {
      place: "Delhi",
      url: "https://goo.gl/maps/dgjCSKvMKXt7SZK88",
    },
  },
  {
    name: "Paragon Restaurant",
    id: Rid.Paragon,
    website: "https://paragonrestaurant.net/",
    location: {
      place: "Trivandrum",
      url: "https://g.page/tvmparagon?share",
    },
  },
  {
    name: "Qureshi Kebab",
    id: Rid.Qureshi,
    location: {
      place: "Near Jama masjid, Delhi",
    },
  },
  {
    id: Rid.Manali,
    location: {
      place: "Manali,Himachal Pradesh",
    },
  },{
    id: Rid.OldSkool,
    name: 'OldSkool',
    location: {
      place: "Trivandrum",
      url:'https://g.page/oldskoolcafediner?share'
    },
  },
];

export const getRestaurant = (id) => restaurantList.find((r) => r.id === id);
